module.exports = __webpack_public_path__ + "static/media/56 - Seu Jorge - Amiga Da Minha Mulher.a097a01d.mp3";